import { render, staticRenderFns } from "./EditArea.vue?vue&type=template&id=4901309f&scoped=true"
import script from "./EditArea.vue?vue&type=script&lang=ts"
export * from "./EditArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4901309f",
  null
  
)

export default component.exports